module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAAQBJREFUKBWFkjsKwkAQhl1jbuMhfEsQtBArC42EpBE7rSwEGysFG8nDs9jZ2FhYWFh4ksR/AhMmxpiFfTDz7fw7s6NKBcPzPCOKoon6x/m+PwjD8KyUGuaCruuOEOQEqG/b9rXyKyLkxrAfMA1AN2LKtMgBORNv2sPWYYj8KWnIObBtNE1rW5b1IIBHIg1oAeMKsw7oyQDvMQi5JbKbI1IN0Iudcld4+BqGma7rDdM039Ipz5lkpFOe42SEdDNXmm+JZFqO42SSSaThPOLSFvMSBEGVA/CeqiMZqeCowA5f10XB77kgOcQX9vh3MhE5wndT5IJ0Ac8objOOTI2L8/QDaHJhG2WhTQAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/prev.png
// module id = O1yb
// module chunks = 0